<div class="control__wrapper bg-light">
    <div [ngClass]="{ 'control__shadow':
        control.elementVal.getValue()?.duringChange === 't' }">
    </div>
    <img class="control__img border-light"
        [ngClass]="{ 'bg-inactive': control.elementVal.getValue()?.duringChange === 't',
            'bg-style': control.elementVal.getValue()?.duringChange === 'f',
            'bg-style__icon': control.elementVal.getValue()?.duringChange === 'f' }"
        ngSrc="{{ setIcon(control.elementVal.getValue()?.iconId) }}"
        width="72" height="72" alt="" />
    <h2 class="control__title"
        [ngClass]="{ 'bg-inactive': control.elementVal.getValue()?.duringChange === 't',
            'bg-style': control.elementVal.getValue()?.duringChange === 'f',
            'bg-style__label': control.elementVal.getValue()?.duringChange === 'f' }">
        {{ subtitle(control.elementVal.getValue()?.txtId) }}
    </h2>
    <div class="control__content">
        <div class="schedule-intervals__days">
            <div class="schedule-intervals__day cursor-pointer "
                 *ngFor="let day of control.elementVal.getValue()?.params.days; let dayIndex = index"
                 [ngClass]="{ 'color-light bg-style border-zone': dayIndex === scheduleIntervals.currentDayIndex,
                    'color-basic border-input': dayIndex !== scheduleIntervals.currentDayIndex }"
                 (click)="scheduleIntervals.setDay(day, dayIndex)">
                <p>{{ dayIndex | longDayName }}</p>
            </div>
        </div>
        <div class="timeline color-basic">
            <div class="timeline__item"
                *ngFor="let hour of scheduleIntervals.hours; let idx = index">
                <div class="timeline__bg"></div>
                <span class="timeline__hour">{{ idx }}</span>
            </div>
            <ng-container *ngFor="let item of scheduleIntervals.intervals; let rangeIndex = index">
                <div class="timeline__range-item bg-alert timeline__bg-color"
                    *ngIf="item.start >= 0 && item.end >= 0
                        && rangeIndex !== scheduleIntervals.currentRangeIndex"
                    [ngStyle]="{ left: ((item.start * 0.0694) + '%'),
                        width: (((item.end - item.start) * 0.0694) + '%') }">
                    <p class="color-light"
                       *ngIf="(item.end - item.start) >= 30">
                       {{ rangeIndex + 1 }}
                    </p>
                </div>
            </ng-container>
            <div class="timeline__range-item bg-gradient"
                *ngIf="scheduleIntervals.showRange"
                [ngStyle]="{ left: ((scheduleIntervals.currentItem.start * 0.0694) + '%'),
                    width: (((scheduleIntervals.currentItem.end
                        - scheduleIntervals.currentItem.start) * 0.0694) + '%') }">
                <p class="color-light"
                    *ngIf="(scheduleIntervals.currentItem.end
                        - scheduleIntervals.currentItem.start) >= 30">
                    {{ scheduleIntervals.currentRangeIndex + 1 }}
                </p>
            </div>
            <span class="timeline__last">24</span>
        </div>
        <div class="schedule-intervals__items">
            <div class="schedule-intervals__item-container"
                *ngFor="let item of scheduleIntervals.intervals; let intervalIndex = index">
                <div class="schedule-intervals__item color-basic cursor-pointer"
                    [attr.data-testid]="'interval-' + intervalIndex"
                    (click)="scheduleIntervals.setRange(intervalIndex)">
                    <div class="schedule-intervals__item-start"
                       [attr.data-testid]="'startInterval-' + intervalIndex">
                       {{ item.start | intervalHour }}
                       {{ ' : ' }}
                       {{ item.start | intervalMin }}
                    </div>
                    <span class="font-14">-</span>
                    <div class="schedule-intervals__item-end"
                        [attr.data-testid]="'endInterval-' + intervalIndex">
                        {{ item.end | intervalHour }}
                        {{ ' : ' }}
                        {{ item.end | intervalMin }}
                    </div>
                </div>
                <div class="schedule-intervals__delete cursor-pointer">
                    <img ngSrc="/assets/img/icons/checkbox_check.svg"
                        width="30" height="30" alt=""
                        [attr.data-testid]="'clearInterval-' + intervalIndex"
                        (click)="scheduleIntervals.clearRangeAlert(intervalIndex)"
                        *ngIf="item.start >= 0 || item.end >= 0">
                </div>
            </div>
        </div>
    </div>

    <div class="schedule-intervals__popup bg-input color-basic"
        data-testid="showRangePopup"
        *ngIf="scheduleIntervals.showRange">
        <div class="schedule-intervals__item">
            <div class="schedule-intervals__item-start">
                <div class="schedule-intervals__change-value">
                    <hold-wrapper (onAction)="scheduleIntervals.increaseValue('start', 'hour')"
                        data-testid="increaseStartHour">
                        <img class="schedule-intervals__arrow cursor-pointer"
                            ngSrc="/assets/img/icons/plus.svg"
                            width="30" height="30" alt="" />
                    </hold-wrapper>
                    <p class="schedule-intervals__value">
                       {{ scheduleIntervals.currentItem.start | intervalHour }}
                    </p>
                    <hold-wrapper (onAction)="scheduleIntervals.reduceValue('start', 'hour')"
                        data-testid="decreaseStartHour">
                        <img class="schedule-intervals__arrow cursor-pointer"
                            ngSrc="/assets/img/icons/minus.svg"
                            width="30" height="30" alt="" />
                    </hold-wrapper>
                </div>
                <span class="font-15">:</span>
                <div class="schedule-intervals__change-value">
                    <hold-wrapper (onAction)="scheduleIntervals.increaseValue('start', 'min')"
                        data-testid="increaseStartMin">
                        <img class="schedule-intervals__arrow cursor-pointer"
                            ngSrc="/assets/img/icons/plus.svg"
                            width="30" height="30" alt="" />
                    </hold-wrapper>
                    <p class="schedule-intervals__value">
                       {{ scheduleIntervals.currentItem.start | intervalMin }}
                    </p>
                    <hold-wrapper (onAction)="scheduleIntervals.reduceValue('start', 'min')"
                        data-testid="decreaseStartMin">
                        <img class="schedule-intervals__arrow cursor-pointer"
                            ngSrc="/assets/img/icons/minus.svg"
                            width="30" height="30" alt="" />
                    </hold-wrapper>
                </div>
            </div>
            <span class="font-18">-</span>
            <div class="schedule-intervals__item-end">
                <div class="schedule-intervals__change-value">
                    <hold-wrapper (onAction)="scheduleIntervals.increaseValue('end', 'hour')"
                        data-testid="increaseEndHour">
                        <img class="schedule-intervals__arrow cursor-pointer"
                            ngSrc="/assets/img/icons/plus.svg"
                            width="30" height="30" alt="" />
                    </hold-wrapper>
                    <p class="schedule-intervals__value">
                        {{ scheduleIntervals.currentItem.end | intervalHour }}
                    </p>
                    <hold-wrapper (onAction)="scheduleIntervals.reduceValue('end', 'hour')"
                        data-testid="decreaseEndHour">
                        <img class="schedule-intervals__arrow cursor-pointer"
                            ngSrc="/assets/img/icons/minus.svg"
                            width="30" height="30" alt="" />
                    </hold-wrapper>
                </div>
                <span class="font-15">:</span>
                <div class="schedule-intervals__change-value">
                    <hold-wrapper (onAction)="scheduleIntervals.increaseValue('end', 'min')"
                        data-testid="increaseEndMin">
                        <img class="schedule-intervals__arrow cursor-pointer"
                            ngSrc="/assets/img/icons/plus.svg"
                            width="30" height="30" alt="" />
                    </hold-wrapper>
                    <p class="schedule-intervals__value">
                       {{ scheduleIntervals.currentItem.end | intervalMin }}
                    </p>
                    <hold-wrapper (onAction)="scheduleIntervals.reduceValue('end', 'min')"
                        data-testid="decreaseEndMin">
                        <img class="schedule-intervals__arrow cursor-pointer"
                            ngSrc="/assets/img/icons/minus.svg"
                            width="30" height="30" alt="" />
                    </hold-wrapper>
                </div>
            </div>
        </div>
        <div class="control__group-btn">
            <button class="control__button bg-default bg-default__button control__button--shadow-active"
                data-testid="closeRangeChange"
                (click)="scheduleIntervals.cancelRange()">
                <img class="control__button-img"
                    ngSrc="/assets/img/zone_icons/back.svg"
                    width="40" height="40" alt="" />
            </button>
            <button class="control__button "
                [ngClass]="{ 'bg-default': control.elementVal.getValue()?.duringChange === 't',
                    'bg-ok bg-ok--accept': control.elementVal.getValue()?.duringChange === 'f' }"
                data-testid="saveRangeChange"
                (click)="scheduleIntervals.saveRange()">
                <img class="control__button-img"
                    ngSrc="/assets/img/icons/ok.svg"
                    width="40" height="40" alt="" />
            </button>
        </div>
    </div>

    <div>
        <button class="schedule-intervals__copy-button control__button control__button--name bg-default font-16"
            (click)="scheduleIntervals.showWeekDays = !scheduleIntervals.showWeekDays">
            <p class="color-light">{{ subtitle(4378) }}</p>
        </button>
        <div class="schedule-intervals__weekday-popup bg-input"
            data-testid="copyDaysList"
            *ngIf="scheduleIntervals.showWeekDays">
            <p class="color-basic">{{ subtitle(4382) }}</p>
            <div class="schedule-intervals__checkbox-container">
                <div class="schedule-intervals__checkbox-weekday control__checkbox-weekday"
                    *ngFor="let day of scheduleIntervals.weekDays; let dayIndex = index">
                    <label class="schedule-intervals__weekday color-basic cursor-pointer">
                        <span class="cursor-pointer">
                            {{ dayIndex | longDayName }}
                        </span>
                        <input class="cursor-pointer" type="checkbox"
                            [disabled]="scheduleIntervals.currentDayIndex == dayIndex"
                            [(ngModel)]="day.selected">
                    </label>
                </div>
            </div>
            <div class="control__group-btn">
                <button class="control__button bg-default bg-default__button control__button--shadow-active"
                    (click)="scheduleIntervals.cancelDays()">
                    <img class="control__button-img"
                        ngSrc="/assets/img/zone_icons/back.svg"
                        width="40" height="40" alt="" />
                </button>
                <button class="control__button "
                    [ngClass]="{ 'bg-default': control.elementVal.getValue()?.duringChange === 't',
                        'bg-ok bg-ok--accept': control.elementVal.getValue()?.duringChange === 'f' }"
                    data-testid="confirmCopyDays"
                    (click)="scheduleIntervals.copyDays()">
                    <img class="control__button-img"
                        ngSrc="/assets/img/icons/ok.svg"
                        width="40" height="40" alt="" />
                </button>
            </div>
        </div>
    </div>

    <div class="control__group-btn">
        <button class="control__button bg-default bg-default__button control__button--shadow-active"
            data-testid="goBackButton"
            (click)="control.hideControl()">
            <img class="control__button-img"
                ngSrc="/assets/img/zone_icons/back.svg"
                width="40" height="40" alt="" />
        </button>
        <button class="control__button"
            [ngClass]="{ 'bg-default': control.elementVal.getValue()?.duringChange === 't',
                'bg-ok bg-ok--accept': control.elementVal.getValue()?.duringChange === 'f' }"
            data-testid="sendButton"
            (click)="scheduleIntervals.returnSchedule()">
            <img class="control__button-img"
                ngSrc="/assets/img/icons/ok.svg"
                width="40" height="40" alt="" />
        </button>
    </div>

    <div *ngIf="control.elementVal.getValue()?.duringChange === 't'"
         class="control__during-change">
        <p class="color-alarm font-18">{{ subtitle(3162) }}</p>
    </div>
</div>
